import { isEqual } from "lodash";
import { useState } from "react";

import { EventTypeQuickFilter } from "./interfaces";

export const useEventTypeQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<EventTypeQuickFilter>({
    eventTypes: {
      eventTypeIds: [],
    },
  });

  const handleChangeQuickFilter = (filter: keyof EventTypeQuickFilter, value: EventTypeQuickFilter["eventTypes"]) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    eventTypeQuickFilter: quickFilter,
    setEventTypeQuickFilter: handleChangeQuickFilter,
  };
};
